var map = {
	"./feather_green.svg": 9489,
	"./feather_grey.svg": 7833,
	"./feather_orange.svg": 5446,
	"./feather_purple.svg": 1398,
	"./feather_red.svg": 6085,
	"./herz.png": 5395,
	"./sturm.png": 3493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6037;